import { Close, Error, Info, Warning } from "@mui/icons-material"
import { Avatar, Box, Card, CardContent, CardHeader, Chip, IconButton, Tab, Tabs, Typography } from "@mui/material"
import CircularProgress from "@mui/material/CircularProgress"
import { useEffect, useState } from "react"
import toast from 'react-hot-toast'
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout"
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar"
import apiService from "../../services/api-service"

function NotificationItem({ notification, onDelete }) {
  const { id, message, severity, created_at, title } = notification

  const getNotificationProps = () => {
    switch (severity) {
      case "INFO":
        return { icon: <Info />, color: "#2196f3", label: "Informazione", bgColor: "#e3f2fd" }
      case "WARNING":
        return { icon: <Warning />, color: "#ff9800", label: "Avviso", bgColor: "#fff3e0" }
      case "ERROR":
        return { icon: <Error />, color: "#f44336", label: "Urgenza", bgColor: "#ffebee" }
      default:
        return { icon: <Info />, color: "#757575", label: "Altro", bgColor: "#f5f5f5" }
    }
  }

  const { icon, color, label, bgColor } = getNotificationProps()

  return (
    <Card
      elevation={0}
      sx={{
        mb: 2,
        borderRadius: 2,
        backgroundColor: bgColor,
        transition: "all 0.3s ease-in-out",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: "0 4px 20px 0 rgba(0,0,0,0.12)",
        },
      }}
    >
      <CardHeader
        avatar={<Avatar sx={{ bgcolor: color }}>{icon}</Avatar>}
        action={
          <Box display="flex" alignItems="center">
            <Chip
              label={label}
              size="small"
              sx={{
                mr: 1,
                color: color,
                borderColor: color,
                backgroundColor: "transparent",
                "& .MuiChip-label": { fontWeight: "bold" },
              }}
              variant="outlined"
            />
            <IconButton size="small" onClick={() => onDelete(id)} aria-label="delete">
              <Close fontSize="small" />
            </IconButton>
          </Box>
        }
        title={
          <Typography variant="subtitle1" fontWeight="bold">
            {title}
          </Typography>
        }
        subheader={
          <Typography variant="caption" color="text.secondary">
            {new Date(created_at).toLocaleString()}
          </Typography>
        }
      />
      <CardContent>
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
      </CardContent>
    </Card>
  )
}

function UserNotification() {
  const [notifications, setNotifications] = useState([])
  const [tabValue, setTabValue] = useState(0)
  const [loading, setLoading] = useState(false);

  useEffect(() => {
      setLoading(true)
      apiService
        .get("/notification/", {},{})
        .then((response) => {
          setLoading(false)
          setNotifications(response)
        })
        .catch((error) => {
          setLoading(false)
          toast.error("Errore durante la chiamata al server, codice d'errore #011112532335", {id: 'user-notification-toast'})
        })
  }, [])

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue)
  }

  const handleDeleteNotification = (id) => {
    apiService.post(
      `/notification/`,
      {},
      { id: id }
    )
      .then(
        apiService
        .get("/notification/", {},{})
        .then((response) => setNotifications(response))
        .catch((error) =>  toast.error("Errore durante la chiamata al server, codice d'errore #011112532335", {id: 'user-notification-toast'}))
      )
      .catch((error) =>  toast.error("Errore durante la chiamata al server, codice d'errore #011344612532335", {id: 'user-notification-toast'}))
  }

  const filteredNotifications =
  tabValue === 0 ? notifications :
  tabValue === 1 ? notifications?.filter(n => n.severity === "INFO") :
  tabValue === 2 ? notifications?.filter(n => n.severity === "WARNING") :
  tabValue === 3 ? notifications?.filter(n => n.severity === "ERROR") : [];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box sx={{ width: "100%", typography: "body1" }}>
        <Tabs value={tabValue} onChange={handleTabChange} centered>
          <Tab label="Tutte" />
          <Tab label="Informazioni" />
          <Tab label="Avvisi" />
          <Tab label="Urgenze" />
        </Tabs>
        <Box sx={{ p: 3 }}>
          { ! loading ?
            <>
              {filteredNotifications?.length > 0 ? (
                filteredNotifications.map(notification => (
                  <NotificationItem
                    key={notification.id}
                    notification={notification}
                    onDelete={handleDeleteNotification}
                  />
                ))
              ) : (
                <Typography variant="body2" color="text.secondary" align="center">
                  Nessuna notifica in questa categoria.
                </Typography>
              )}
            </>
            :
            <center>
              <CircularProgress size={120} sx={{marginTop: "250px", color: "#2b84ea"}}/>
            </center>
          }
        </Box>
      </Box>
    </DashboardLayout>
  )
}

export default UserNotification
